import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '@/locales/en';
import nl from '@/locales/nl';

const storageKey = 'asset-management-language';
const storedLanguage = localStorage.getItem(storageKey);
// Dutch is the default per Belgian usage conventions; fall back to it for
// unrecognized/missing stored values rather than trusting arbitrary input.
const initialLanguage = storedLanguage === 'en' || storedLanguage === 'nl' ? storedLanguage : 'nl';

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      nl: { translation: nl },
    },
    lng: initialLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

// Persist the user's language choice so it survives reloads/sessions.
i18n.on('languageChanged', (lng) => {
  localStorage.setItem(storageKey, lng);
});

export default i18n;
